import { ADD_LOCATION } from "../../types/LocationType";
import axios from "axios";
import { toast } from "react-toastify";

const addLocationAction = (data) => ({
  type: ADD_LOCATION,
  payload: data,
});

export const addLocation = (values) => {
  return async (dispatch) => {
    try {
      const { data } = await axios({
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: "location/",
        data: { ...values },
      });
      dispatch(addLocationAction(data));
      toast.success("Location added");
      return { message: "success", data };
    } catch (error) {
      toast.error(error.response?.data?.message || "Error adding location");
      console.log(error.message);
    }
  };
};
